import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { linkedAccountDetailsReducer } from "../../components/shared/Account/CustomAccountCard/CustomAccountCardSlice";
import { resetStateExcept } from "../../Services/helper";
import { billingAddressReducer } from "../Slices/AccountSlice";
import { adminAuthorization } from "../Slices/AdminAuthSlice";
import { appProposalReducer } from "../Slices/AppProposalSlice";
import { autopayPaperlessReducer } from "../Slices/AutoPayPaperlessSlice";
import { billingInfoReducer } from "../Slices/BillingInfoSlice";
import { customerInfoDetailsReducer } from "../Slices/CustomerInfoSlice";
import { editAutoPayReducer } from "../Slices/EditAutoPaySlice";
import { equipmentReturnReducer } from "../Slices/EquipmentReturnSlice";
import { adminUserName, isAdminFlagReducer } from "../Slices/IsAdminSlice";
import { networkStatusReducer } from "../Slices/NetworkStatusSlice";
import { orderAndServiceTicketHistorySliceReducer } from "../Slices/OrderAndServiceTicketSLice";
import { orderDetailReducer } from "../Slices/OrderDetailsSlice";
import { orderUpgradeReducer } from "../Slices/OrderUpgradeSlice";
import { pageReducer } from "../Slices/PageSlice";
import { paymentDetailReducer } from "../Slices/PaymentSlice";
import { customerPlanDetailsReducer } from "../Slices/PlanDetailsSlice";
import { sideCoreContentReducer } from "../Slices/SideCoreContentSlice";
import { signInReducer } from "../Slices/SignInSlice";
import { speedAnimationReducer } from "../Slices/SpeedTestAnimationSlice";
import { supportDetailsReducer } from "../Slices/SupportSlice";
import { troubleTicketReducer } from "../Slices/TroubleTicketSlice";
import { userInfoReducer } from "../Slices/UserSlice";

const appReducer = combineReducers({
  customerInfoDetails: customerInfoDetailsReducer,
  billingAddress: billingAddressReducer,
  linkedAccountDetails: linkedAccountDetailsReducer,
  editAutoPay: editAutoPayReducer,
  customerPlanDetails: customerPlanDetailsReducer,
  userInfo: userInfoReducer,
  autopayPaperlessDetails: autopayPaperlessReducer,
  paymentDetails: paymentDetailReducer,
  supportDetails: supportDetailsReducer,
  isAdminFlag: isAdminFlagReducer,
  adminUserName: adminUserName,
  billingInfo: billingInfoReducer,
  isAuthenticated: adminAuthorization,
  pageInfo: pageReducer,
  appProposal: appProposalReducer,
  speedTestAnimation: speedAnimationReducer,
  orderDetails: orderDetailReducer,
  signInDetails: signInReducer,
  troubleTicketDetails: troubleTicketReducer,
  networkStatusDetails: networkStatusReducer,
  orderAndServiceTicketHistory: orderAndServiceTicketHistorySliceReducer,
  OrderUpgradeDetails: orderUpgradeReducer,
  sideCoreContent: sideCoreContentReducer,
  equipmentReturnDetails: equipmentReturnReducer,
});

const rootReducer = (state: any, action: any) => {
  switch (action.type) {
    case "EXIT_ACCOUNT_LAC":
      return appReducer(resetStateExcept(state, ["isAuthenticated"]), action);

    case "USER_LOGOUT":
      return appReducer(undefined, action);

    default:
      return appReducer(state, action);
  }
};

export const store = configureStore({
  reducer: rootReducer,
});
export type RootState = ReturnType<typeof store.getState>;
export default rootReducer;
